import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, path = '/', type = 'website' }) => {
  const baseUrl = 'https://www.webisula.com';
  const fullUrl = `${baseUrl}${path}`;
  const defaultTitle = 'WEBISULA | Agence web en Corse - Sites internet Ajaccio';
  const fullTitle = title ? `${title} | WEBISULA` : defaultTitle;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
